import * as storageKeyHelpers from "./storageKeyHelpers";
import * as users from "./api/users";
import cacheEnhancer from "./api/cacheEnhancer";
import localforage from "localforage";

const GROUP_KEY_ROOT = "group";

function getGroupKey(groupId, includeUsage, libraryName) {
	let key = `${GROUP_KEY_ROOT}-${groupId}-${includeUsage}`;
	if (libraryName) {
		key += `-${libraryName}`;
	}
	return key;
}

export function initialize() {
	localforage.config({
		name: "docket-navigator",
		verison: 1.0,
	});
}

export function clearExpired() {
	const expiredKeys = [];
	return localforage
		.iterate((value, key) => {
			if (value.expiresAt < Date.now() || value.clientVersion !== __VERSION__) {
				expiredKeys.push(key);
			}
		})
		.then(() => {
			if (__DEV__ && expiredKeys.length > 0) {
				console.info("Removing expired storage items", expiredKeys);
			}

			return Promise.all(expiredKeys.map(key => localforage.removeItem(key)));
		});
}

export function clearAll() {
	const keys = [];
	return localforage
		.iterate((value, key) => {
			keys.push(key);
		})
		.then(() => {
			return Promise.all(keys.map(key => localforage.removeItem(key)));
		});
}

export function getGroup(groupId, includesUsage, libraryName) {
	const groupKey = getGroupKey(groupId, includesUsage, libraryName);
	return cacheEnhancer(users.networkCatalog, groupKey, 600, true)(
		groupId,
		includesUsage,
		libraryName,
	);
}

export function clearGroup(groupId) {
	const groupUsageKey = getGroupKey(groupId, true, null);
	const groupKey = getGroupKey(groupId, false, null);
	return Promise.all([localforage.removeItem(groupKey), localforage.removeItem(groupUsageKey)]);
}

export function clearProfileBinder(libraryName, binderType, binderId) {
	const key = storageKeyHelpers.getProfileBinderKey(libraryName, binderType, binderId);
	return localforage.removeItem(key);
}

function getSearchGridKey(binderId, tabId, tileId) {
	const tileStr = tileId ? `${tileId}-` : "";
	return `grid-${binderId}-${tabId}-${tileStr}`;
}

export function getSearchGridPageKey(binderId, tabId, tileId, start, limit) {
	return `${getSearchGridKey(binderId, tabId, tileId)}${start}-${limit}`;
}

export async function clearSearchGrid(binderId, tabId, tileId) {
	const currentGridKey = getSearchGridKey(binderId, tabId, tileId);
	const localForageKeys = await localforage.keys();
	const binderTabKeys = localForageKeys.filter(k => k.indexOf(currentGridKey) === 0);
	return Promise.all(binderTabKeys.map(k => localforage.removeItem(k)));
}
